module.exports = __webpack_public_path__ + "img/14.026a81ba.png";